import { Typography } from '@eventbrite/marmalade';
import { css, cx } from 'emotion';
import React from 'react';
import { useIsFirstHierarchyLevel } from '../../experimentation';
import { getCreatorVerificationBadge } from '../../experimentation/experiments';
import { CreatorBadge } from '../_shared/OrganizerInfo/CreatorBadgeVariantA/CreatorBadge';

type PageTitleProps = {
    pageTitle: string;
    hideStartDate: boolean;
    isMobile?: boolean;
    showBadge?: boolean;
};

const titleCustomStyle = (hideStartDate: boolean) => css`
    ${hideStartDate &&
    `
    @media (max-width: 960px) {
        width: 80%;
    }
    `}
`;

const creatorBadgeStyle = () => css`
    display: inline-flex;
    vertical-align: middle;
`;

export const PageTitle = ({
    pageTitle,
    hideStartDate,
    isMobile,
    showBadge,
}: PageTitleProps) => {
    const isFirstHierarchyLevel = useIsFirstHierarchyLevel();
    const showVariantType =
        pageTitle && showBadge ? getCreatorVerificationBadge() : 'control';

    const shouldRenderBadge = isMobile && showBadge;
    const renderBadge = () => {
        return (
            <>
                <span>{pageTitle}</span>
                {shouldRenderBadge && (
                    <div className={creatorBadgeStyle()}>
                        <CreatorBadge variantSource="verification-tick" />
                    </div>
                )}
            </>
        );
    };
    return (
        <>
            {pageTitle && (
                <>
                    {isFirstHierarchyLevel ? (
                        <Typography
                            as="h1"
                            color="neutral-1000"
                            variant="heading-md"
                        >
                            {pageTitle}
                        </Typography>
                    ) : (
                        <h1
                            className={cx(
                                'event-title',
                                titleCustomStyle(hideStartDate),
                            )}
                        >
                            {showVariantType === 'variant_b'
                                ? renderBadge()
                                : pageTitle}
                        </h1>
                    )}
                </>
            )}
        </>
    );
};
